import moment from "moment";
import { session, UNAUTHORIZED_MESSAGES, TOKEN_EXPIRED_MESSAGE } from "./session";
import { API } from "../config.js";

export default async function (url, options) {
  try {
    const response = await fetch(url, options);
    const _response = await response.clone();

    if (response?.status >= 400) {
      const responseJSON = await response.json();
      const errorMessage = responseJSON?.error;

      if (UNAUTHORIZED_MESSAGES.includes(errorMessage))
        return session.deleteSession()

      if (TOKEN_EXPIRED_MESSAGE.includes(errorMessage))
        return session.retryWithRefreshToken((accessToken) => {
          options.headers["Authorization"] = `Bearer ${accessToken}`;

          return fetch(url, options);
        });

      return _response;
    }

    return _response;
  } catch (error) {
    throw error;
  }
}
